import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetSmsTemplateByTypeQueryVariables = Types.Exact<{
  type: Types.Scalars['String']['input'];
}>;


export type GetSmsTemplateByTypeQuery = { __typename?: 'query_root', smstemplates: Array<{ __typename?: 'smstemplates', id: number, name: string, type: string, template: string }> };


export const GetSmsTemplateByTypeDocument = gql`
    query getSmsTemplateByType($type: String!) {
  smstemplates(where: {type: {_eq: $type}}, limit: 1) {
    id
    name
    type
    template
  }
}
    `;

/**
 * __useGetSmsTemplateByTypeQuery__
 *
 * To run a query within a React component, call `useGetSmsTemplateByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmsTemplateByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmsTemplateByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetSmsTemplateByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetSmsTemplateByTypeQuery, GetSmsTemplateByTypeQueryVariables> & ({ variables: GetSmsTemplateByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmsTemplateByTypeQuery, GetSmsTemplateByTypeQueryVariables>(GetSmsTemplateByTypeDocument, options);
      }
export function useGetSmsTemplateByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmsTemplateByTypeQuery, GetSmsTemplateByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmsTemplateByTypeQuery, GetSmsTemplateByTypeQueryVariables>(GetSmsTemplateByTypeDocument, options);
        }
// @ts-ignore
export function useGetSmsTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmsTemplateByTypeQuery, GetSmsTemplateByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsTemplateByTypeQuery, GetSmsTemplateByTypeQueryVariables>;
export function useGetSmsTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsTemplateByTypeQuery, GetSmsTemplateByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmsTemplateByTypeQuery | undefined, GetSmsTemplateByTypeQueryVariables>;
export function useGetSmsTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmsTemplateByTypeQuery, GetSmsTemplateByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmsTemplateByTypeQuery, GetSmsTemplateByTypeQueryVariables>(GetSmsTemplateByTypeDocument, options);
        }
export type GetSmsTemplateByTypeQueryHookResult = ReturnType<typeof useGetSmsTemplateByTypeQuery>;
export type GetSmsTemplateByTypeLazyQueryHookResult = ReturnType<typeof useGetSmsTemplateByTypeLazyQuery>;
export type GetSmsTemplateByTypeSuspenseQueryHookResult = ReturnType<typeof useGetSmsTemplateByTypeSuspenseQuery>;
export type GetSmsTemplateByTypeQueryResult = Apollo.QueryResult<GetSmsTemplateByTypeQuery, GetSmsTemplateByTypeQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/guestRides/queries/getSmsTemplateByType.query.gql}
 */
export async function getSmsTemplateByType(
  variables: GetSmsTemplateByTypeQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetSmsTemplateByTypeQuery['smstemplates']>
export async function getSmsTemplateByType(
  variables: GetSmsTemplateByTypeQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetSmsTemplateByTypeQuery>
export async function getSmsTemplateByType(
  variables: GetSmsTemplateByTypeQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetSmsTemplateByTypeQuery['smstemplates'] | GetSmsTemplateByTypeQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetSmsTemplateByTypeQuery>(
    GetSmsTemplateByTypeDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.smstemplates
}